<h2 mat-dialog-title>
  <mat-icon class="title-icon">swap_horiz</mat-icon>
  Confirm Gym Type Change
</h2>

<mat-dialog-content>

  <div class="change-summary">
    <div class="change-column">
      <span class="change-label">From</span>
      <div class="change-values">
        @for (label of previousTypeLabels; track label) {
          <span class="change-value">{{ label }}</span>
        }
        @if (!previousTypeLabels.length) {
          <span class="change-value empty">None</span>
        }
      </div>
    </div>
    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
    <div class="change-column">
      <span class="change-label">To</span>
      <div class="change-values">
        @for (label of newTypeLabels; track label) {
          <span class="change-value">{{ label }}</span>
        }
        @if (!newTypeLabels.length) {
          <span class="change-value empty">None</span>
        }
      </div>
    </div>
  </div>

  <div class="danger-banner">
    <mat-icon class="danger-icon">error</mat-icon>
    <div>
      <strong>This action can impact live members</strong>
      <p>Changing the gym type affects check-ins, policies, and access integrations. Please read carefully before confirming.</p>
    </div>
  </div>

  <p class="section-heading">This change will have the following impact:</p>

  <div class="consequence-list">
    <div class="consequence-item">
      <mat-icon class="consequence-icon warn">sync_problem</mat-icon>
      <div>
        <strong>Check-ins may be affected</strong>
        <p>User membership network is validated against the gym network. Existing members could lose check-in access.</p>
      </div>
    </div>

    @if (data.classBookingEnabled) {
      <div class="consequence-item">
        <mat-icon class="consequence-icon warn">event_busy</mat-icon>
        <div>
          <strong>Cancellation policies will be reset</strong>
          <p>Class booking cancellation policies will revert to a default with no fees for the new network.</p>
        </div>
      </div>

      <div class="consequence-item">
        <mat-icon class="consequence-icon warn">verified_user</mat-icon>
        <div>
            <strong>Class Booking re-validation required</strong>
            <p>You will need to review and update the policy for each active access integration after this change.</p>
        </div>
      </div>
    }
    
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button
    mat-flat-button
    color="warn"
    (click)="confirm()">
    Confirm Change
  </button>
</mat-dialog-actions>
